/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React from 'react'
import { Text } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import * as ResourceManager from '../methods/ResourceManager'
import styles from '../../styles'
import LightStageDetails from './LightStageDetails'

function YellowCallDoctorPage(props) {
    const { t } = props
    return (
      <LightStageDetails
        analyticsEvent="YellowCallDoctor"
        sourceImage={ResourceManager.loadImage('yellow_doc_header')}
        sourceImageStyle={{ width: 76, height: 59 }}
        accessibilityLabel={t('access:yellowCallDoctorImage')}
      >
        <Text style={styles.lightStageHeader} testID="light-state-details-header">{t('yellowCallDoctorTitle')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('whatItMeans')}</Text>
        <BulletedListView
          headingText={t('yellowCallDoctorWhatItMeansErrorList')}
        >
          <Text style={textStyles.detailText}>{t('yellowCallDoctorWhatItMeansErrorBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('yellowCallDoctorWhatItMeansErrorBulletTwo')}</Text>
        </BulletedListView>
        <Text style={textStyles.bodyContentText}>{t('yellowCallDoctorWhatItMeansOne')}</Text>
        <Text style={textStyles.bodyContentText}>
          {t('yellowCallDoctorWhatItMeansTwo')}
        </Text>
        <Text style={styles.lightStageDetailsHeading}>{t('ifYouSeeThis')}</Text>
        <Text style={textStyles.bodyContentText}>{t('common:callYourHealthCareProvider')}</Text>
      </LightStageDetails>
    )
}

YellowCallDoctorPage.propTypes = {
  t: PropTypes.func.isRequired,
}

export const YellowCallDoctorPageComponent = YellowCallDoctorPage

export default withTranslation(['indicatorLights'])(YellowCallDoctorPage)
